import styled from 'styled-components';
import { toRem, baseVariables } from '../../styles';
import { Button } from '../../atoms/Button';

export const StyledGeneralMessage = styled.div<{
  styleclass: string | undefined;
  collapsed?: boolean;
}>`
  display: flex;
  background-color: ${props =>
    props.styleclass?.includes('urgent') ? `${baseVariables.color.alert50}` : `${baseVariables.color.base10}`};
  height: 100%;
  overflow: hidden;
  position: relative;
  border: ${toRem(1)} solid ${baseVariables.color['neutral20']};
  box-shadow: ${baseVariables.shadows['shadowSubtle04']};
  align-items: center;
  justify-content: center;
  .gm {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: ${toRem(16)};
    padding-bottom: ${toRem(16)};
    padding: ${toRem(16)} ${toRem(32)};
    @media ${baseVariables.mediaQuery.md} {
      padding: ${toRem(16)} ${toRem(0)};
    }
    &_heading {
      text-align: center;
      padding: 0 ${toRem(28)};
    }
    &_text {
      color: ${baseVariables.color.base20};
    }
    &_description {
      text-align: center;
    }
    &_collapse {
      position: absolute;
      top: 50% !important;
      transform: translateY(-50%) !important;
      height: 100%;
      padding-right: ${toRem(8)};
      right: 0;
      color: ${baseVariables.color.base20};
      display: flex;
      align-items: center;

      span {
        height: max-content;
      }
    }
    &_link {
      background-color: transparent;
    }
    @media ${baseVariables.mediaQuery.md} {
      .gm_heading {
        margin-bottom: ${toRem(4)};
        padding: 0 ${toRem(32)};
      }
    }
    .m-link-tertiary-button-external,
    .m-link-tertiary-button-external a {
      color: inherit;
    }
  }

  ${props => {
    if (props.collapsed) {
      return `
        .gm_collapse {
          height: fill-available;
          top: unset;
          bottom: unset;
        }
      `;
    }
    return '';
  }}
`;

export const DescriptionWrapper = styled.div`
  align-items: baseline;
  flex-wrap: wrap;

  p {
    display: inline;
    margin-bottom: ${toRem(4)};
  }
`;

export const StyledButton = styled(Button)`
  text-decoration: underline !important;
  flex-shrink: 0;

  // temporary fix for tertiary link button
  ::after {
    padding-left: ${toRem(5)} !important;
  }
`;
